import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './TermsAndPrivacy.module.css';

const TermsAndPrivacy = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // 根据 hash 滚动到对应区域
  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
      }
    }
  }, [location.hash]);

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={() => navigate(-1)}
          aria-label="返回上一页"
        >
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <h1 className={styles.title}>服务条款与隐私政策</h1>
      </header>

      <main className={styles.content}>
        {/* ========== 服务条款 ========== */}
        <section className={styles.section} id="terms">
          <div className={styles.sectionIcon}>
            <span className="material-icons-outlined">gavel</span>
          </div>
          <h2 className={styles.sectionTitle}>服务条款</h2>
          <p className={styles.updateDate}>最后更新日期：2026 年 2 月 22 日</p>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>1. 服务概述</h3>
            <p className={styles.text}>
              感谢您选择我们的英语阅读学习平台。在这里，您可以阅读中文小说的英文译版，使用单词与句子收藏、AI 笔记、音频播放等功能，让学英语更轻松。使用本平台即表示您知晓并同意以下条款，我们会尽力为您提供稳定、友好的服务。
            </p>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>2. 账户注册与安全</h3>
            <ul className={styles.list}>
              <li>建议您使用真实、准确的信息完成注册，以便我们更好地为您服务。</li>
              <li>请妥善保管您的账户密码；若因密码泄露造成不便，我们建议您尽快修改密码并联系我们。</li>
              <li>为保障您的权益，每个账户仅供本人使用，请勿转让、出借或与他人共享。</li>
              <li>如发现账户异常，欢迎随时通过应用内反馈或邮件联系我们，我们会尽快协助处理。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>3. VIP 会员服务与付费</h3>
            <ul className={styles.list}>
              <li>我们提供月付、年付等一次性购买的 VIP 会员服务，具体以购买页为准。</li>
              <li>所有付款均通过 <strong>Stripe</strong> 安全处理，我们不会存储您的银行卡等支付信息。</li>
              <li>价格以下单时页面显示为准；若未来调整价格，将仅对新订单生效。</li>
              <li>VIP 权益在付款成功后立即生效，有效期依您选择的套餐而定。</li>
              <li>会员到期后，若未再次购买，账户将恢复为免费状态，部分功能会有所限制。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>4. 退款政策</h3>
            <ul className={styles.list}>
              <li>由于数字内容在购买后即可使用，一般情况下我们无法为您办理退款。</li>
              <li>若您在付款后 24 小时内尚未使用任何 VIP 专属功能，可以申请全额退款，我们很乐意协助处理。</li>
              <li>请通过应用内反馈或邮件联系客服，我们会尽快回复；退款将经原支付渠道（Stripe）退回，通常需要 5–10 个工作日。</li>
              <li>因个人原因导致的付费（例如误操作等），可能无法纳入退款范围，如有特殊情况欢迎向我们说明。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>5. 知识产权</h3>
            <ul className={styles.list}>
              <li>平台上的文本、音频、翻译、AI 笔记、界面设计等内容均受版权保护，还请您不要未经授权复制、转载或传播。</li>
              <li>您在平台内创建的个人笔记、收藏记录等数据属于您本人，我们尊重并保护您的创作与数据。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>6. 用户行为规范</h3>
            <ul className={styles.list}>
              <li>为了大家都能安心使用，我们希望您不要使用自动化工具批量抓取或下载平台内容。</li>
              <li>请勿传播违法、淫秽、侮辱或侵犯他人权益的内容，也不要干扰或破坏平台正常运行。</li>
              <li>若出现严重违规情况，我们可能不得不暂停或终止相关账户的服务，还请理解。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>7. 免责声明</h3>
            <ul className={styles.list}>
              <li>我们会尽力保持服务稳定、准确，但无法保证永无中断或差错，感谢您的理解。</li>
              <li>若因不可抗力（如服务器故障、网络中断等）导致服务暂时不可用，我们可能无法为此承担赔偿责任，但会尽快恢复服务。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>8. 条款修改</h3>
            <p className={styles.text}>
              我们有时会更新本服务条款，更新后的内容会发布在本页面。若您继续使用本平台，即视为同意当时的条款。如有重要变更，我们会通过站内通知或邮件等方式告知您，方便您随时了解。
            </p>
          </div>
        </section>

        {/* ========== 隐私政策 ========== */}
        <section className={styles.section} id="privacy">
          <div className={styles.sectionIcon}>
            <span className="material-icons-outlined">shield</span>
          </div>
          <h2 className={styles.sectionTitle}>隐私政策</h2>
          <p className={styles.updateDate}>最后更新日期：2026 年 2 月 22 日</p>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>1. 信息收集</h3>
            <p className={styles.text}>为了给您提供更好的服务，我们可能会收集以下信息：</p>
            <ul className={styles.list}>
              <li><strong>账户信息：</strong>您注册时填写的用户名、邮箱、手机号等。</li>
              <li><strong>个人资料：</strong>您自愿上传的头像等。</li>
              <li><strong>使用数据：</strong>阅读记录、收藏的单词与句子、笔记、学习进度等，用于为您提供个性化体验。</li>
              <li><strong>设备信息：</strong>浏览器类型、操作系统、IP 等，便于我们优化兼容性与安全。</li>
              <li><strong>支付相关：</strong>我们仅保留交易状态等必要信息；您的银行卡信息由 Stripe 直接处理与存储，我们不会接触或保存您的完整卡号。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>2. 信息使用</h3>
            <p className={styles.text}>我们使用这些信息，主要是为了：</p>
            <ul className={styles.list}>
              <li>为您提供并不断改进阅读、收藏、笔记、音频等核心功能。</li>
              <li>根据您的使用习惯，推荐更合适的阅读与学习内容。</li>
              <li>在合规前提下分析产品使用情况，以优化体验。</li>
              <li>保障平台安全，防范欺诈与滥用。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>3. 信息共享</h3>
            <p className={styles.text}>我们不会出售您的个人信息。在以下情况中，我们可能会共享必要信息：</p>
            <ul className={styles.list}>
              <li><strong>支付：</strong>付款由 Stripe 处理，其会按自身<a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">隐私政策</a>处理您的支付信息。</li>
              <li><strong>法律要求：</strong>当法律或司法程序有明确要求时，我们可能依法披露相关信息。</li>
              <li><strong>合作方：</strong>我们可能向云存储、分析等协助我们运营的合作伙伴提供有限信息，并会要求其严格保密。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>4. Stripe 支付安全</h3>
            <ul className={styles.list}>
              <li>所有支付均经 Stripe 处理，采用行业通用的 SSL/TLS 加密。</li>
              <li>Stripe 已通过 PCI DSS Level 1 认证，我们仅保存交易状态等必要信息，不保存您的卡号、CVV 等敏感数据。</li>
              <li>想了解更多可查看 <a href="https://stripe.com/docs/security" target="_blank" rel="noopener noreferrer">Stripe 安全说明</a>。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>5. 数据存储与保护</h3>
            <ul className={styles.list}>
              <li>您的数据存放在安全的云环境中，我们采用合理的技术与管理措施加以保护。</li>
              <li>数据传输使用 HTTPS 加密，并会定期审视安全措施。</li>
              <li>我们会尽力保护您的数据，但无法保证网络环境绝对无风险，还请您理解。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>6. Cookie 使用</h3>
            <p className={styles.text}>
              我们使用 Cookie 等类似技术来保持您的登录状态、记住主题与深色模式等偏好，以便您获得连贯的使用体验。这些属于功能性 Cookie，我们不会用其做广告追踪。
            </p>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>7. 您的权利</h3>
            <p className={styles.text}>我们重视您对个人数据的控制权，您有权：</p>
            <ul className={styles.list}>
              <li><strong>访问与查看：</strong>随时在账户中查看您的个人信息。</li>
              <li><strong>更正：</strong>在设置中更新或修正您的资料。</li>
              <li><strong>删除与导出：</strong>如需删除账户或导出个人数据，请通过应用内反馈或邮件联系我们，我们会按流程协助您。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>8. 未成年人保护</h3>
            <p className={styles.text}>
              本平台不面向 13 岁以下儿童。若我们得知误收了 13 岁以下儿童的信息，会尽快删除。若您作为家长或监护人发现孩子向我们提供了个人信息，欢迎联系我们，我们会妥善处理。
            </p>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>9. 隐私政策更新</h3>
            <p className={styles.text}>
              我们可能会不时更新本隐私政策，更新内容会发布在本页面。建议您偶尔查阅以便了解最新说明；如有重要变更，我们会通过站内通知等方式告知您。
            </p>
          </div>
        </section>

        {/* ========== 联系我们 ========== */}
        <section className={styles.contactSection}>
          <div className={styles.contactIcon}>
            <span className="material-icons-outlined">mail</span>
          </div>
          <h3 className={styles.contactTitle}>联系我们</h3>
          <p className={styles.text}>
            若您对服务条款或隐私政策有任何疑问或建议，欢迎随时联系我们，我们会认真对待每一条反馈。
          </p>
          <div className={styles.contactMethods}>
            <a className={styles.contactLink} href="mailto:ennovels@outlook.com">
              <span className="material-icons-outlined">email</span>
              ennovels@outlook.com
            </a>
            <p className={styles.contactNote}>我们一般会在 2 个工作日内回复您的邮件。</p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TermsAndPrivacy;

